import { Select, Space } from 'antd';
import { useBackoffice, ALL_DEVELOPERS } from './useBackoffice';

import { UserIcon } from '@heroicons/react/24/outline';
import { css } from '@emotion/css';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export const DeveloperAccountSelectPanel = () => {
  const { setDeveloperId, developerId } = useBackoffice();
  const [searchParams, setSearchParams] = useSearchParams();

  const spaceStyles = css`
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 16px;
  `;

  useEffect(() => {
    const queryDeveloperId = searchParams.get('developerId');
    if (queryDeveloperId && !developerId) {
      setDeveloperId(queryDeveloperId);
    }
  }, [searchParams, developerId, setDeveloperId]);

  const handleDeveloperIdChange = (newDeveloperId: string | null) => {
    // Update the state
    setDeveloperId(newDeveloperId);

    // Update the URL query parameter
    const newSearchParams = new URLSearchParams(searchParams);
    if (newDeveloperId) {
      newSearchParams.set('developerId', newDeveloperId);
    } else {
      newSearchParams.delete('developerId');
    }
    setSearchParams(newSearchParams, { replace: true });
  };

  return (
    <Space className={spaceStyles}>
      <Select
        placeholder="Select Developer Account"
        value={developerId}
        onChange={handleDeveloperIdChange}
        style={{ width: 250 }}
        allowClear
        prefix={<UserIcon />}
        options={ALL_DEVELOPERS.map((dev) => ({
          value: dev.id,
          label: dev.name,
        }))}
      />
    </Space>
  );
};
